// material-ui
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { ResolvePath } from 'features/firebase-app'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Accordion from 'ui-component/extended/Accordion'

import { Divider, Grid, Typography } from '@mui/material'
import { uuid } from 'components/util'
import * as SC from 'features/shared_components'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'
import SubCard from 'ui-component/cards/SubCard'

import { gridSpacing } from 'store/constant'

import { Views } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import Busy from 'components/Busy'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_contentHouse,
  setSelectedcontentHouse,
} from 'features/contentHouse/contentHouse-slice'
import { get_all_contentHouseMediaSnapshot } from 'features/contentHouseMediaSnapshot/contentHouseMediaSnapshot-slice'
import { get_all_releaseScheduleAction } from 'features/releaseScheduleAction/releaseScheduleAction-slice'
import {
  get_all_series,
  get_selected_series,
  setSelectedseries,
} from 'features/series/series-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  const params = useParams()
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let claims = useSelector(getUserClaims)
  let series_list = useSelector(get_all_series)
  let series = useSelector(get_selected_series)
  let contentHouse_list = useSelector(get_all_contentHouse)
  let contentHouseMediaSnapshot_list = useSelector(
    get_all_contentHouseMediaSnapshot,
  )
  let releaseScheduleAction_list = useSelector(get_all_releaseScheduleAction)
  const [contextId, setContextId] = React.useState(null)
  const [updateArg, setUpdateArg] = React.useState(null)

  useEffect(() => {
    if (claims?.player && params?.id) {
      dispatch(
        autoThunks.get_series_for_release_management_by_content_house({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.player, params?.id])
  useEffect(() => {
    if (claims?.player && params?.id) {
      dispatch(
        autoThunks.get_contenthouse_for_release_management_by_content_house({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.player, params?.id])
  useEffect(() => {
    if (claims?.player && params?.id && series?.id) {
      dispatch(
        autoThunks.get_content_house_media_snapshot_for_release_management_by_content_house(
          { fire_user: claims?.user, contentHouseId: params?.id },
        ),
      )
    }
  }, [claims?.player, params?.id, series?.id])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.get_contet_houses_for_release_management({
          fire_user: claims?.user,
        }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && params?.id) {
      dispatch(
        autoThunks.get_releasescheduleactions_for_release_management_by_content_house(
          { fire_user: claims?.user, contentHouseId: params?.id },
        ),
      )
    }
  }, [claims?.player, params?.id])
  useEffect(() => {
    if (claims?.player && updateArg) {
      dispatch(
        autoThunks.update_release_schedule_action_for_release_management({
          fire_user: claims?.user,
          contentHouseId: params?.id,
          args: (() => {
            function getUpdateArg(): any {
              return updateArg
            }
            return getUpdateArg()
          })(),
        }),
      )
    }
  }, [claims?.player, updateArg])

  function seriesComponent(): any {
    return (
      <>
        {SC.sharedList(
          (series_list || []).filter(
            (x) => !x.deleted && x.owner === params?.id,
          ),
          SC.sharedListItemBuilder,
          (item) => {
            return {
              name: item?.name || TitleService('Unknown'),
              date: item?.created || item.updated,
              statusColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.dark.main
                  : theme.palette.primary.light,
              getIcon: () => {
                return (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-map-2"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#597e8d"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="18" y1="6" x2="18" y2="6.01" />
                    <path d="M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5" />
                    <polyline points="10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15" />
                    <line x1="9" y1="4" x2="9" y2="17" />
                    <line x1="15" y1="15" x2="15" y2="20" />
                  </svg>
                )
              },
            }
          },
          (item) => {
            dispatch(setSelectedseries(item?.id))
            setContextId(uuid())
          },
        )}
      </>
    )
  }

  let output_seriesComponent = seriesComponent()

  function seasonRelaseManagementComponent(): any {
    return (() => {
      function get_accordion_season_data() {
        if (series?.id) {
          let actions = (releaseScheduleAction_list || []).filter(
            (x) => x.seriesId === series?.id,
          )
          let _snap = (contentHouseMediaSnapshot_list || [])
            .filter((c) => {
              return c.series.id === series?.id
            })
            .sort((a: any, b: any) => {
              return b.updated._seconds - a.updated._seconds
            })
            .find((v) => v)
          if (_snap) {
            return _snap.seasons.map((season) => {
              let seasonEpisodes =
                season?.media?.map((y) => {
                  return _snap?.media?.find((x) => x.id === y.id)
                }) || []
              return {
                id: season?.id,
                defaultExpand: false,
                title: (
                  <>
                    <Typography variant="subtitle1" color="primary">
                      {season?.name}
                    </Typography>
                  </>
                ),
                content: (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={12}>
                      {SC.SnapSeasonTable(
                        seasonEpisodes,
                        {
                          ..._snap,
                          actions,
                          seriesId: series?.id,
                          seasonId: season.id,
                        },
                        SC.SnapMediaReleaseActionRowBuilder,
                        (args: any) => {
                          setUpdateArg({
                            ...args,
                          })
                        },
                      )}
                    </Grid>
                  </Grid>
                ),
              }
            })
          }
        }
        return []
      }

      return (
        <>
          <SubCard title={series?.name || TitleService('Unknown')}>
            <Accordion
              expandIcon={<ArrowDropDownIcon />}
              data={get_accordion_season_data()}
            />
          </SubCard>
        </>
      )
    })()
  }

  let output_seasonRelaseManagementComponent = seasonRelaseManagementComponent()

  function main_card(modelList: any, modelForm: any): any {
    return (
      <>
        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="contentHouse-label">
            {TitleService('Content House')}
          </InputLabel>
          <Select
            labelId="contentHouse-label"
            id="contentHouse-select"
            value={params?.id}
            label={TitleService('Content House')}
            onChange={(val: any) => {
              dispatch(setSelectedcontentHouse(val?.target?.value))
              navigate(
                ResolvePath(
                  `/${Views.ReleaseManagement}/${val?.target?.value}`,
                ),
              )
            }}
          >
            <MenuItem value="">{TitleService('Select Content House')}</MenuItem>
            {(contentHouse_list || []).map((item) => {
              return (
                <MenuItem value={item.id} key={item.id}>
                  {item.name}
                </MenuItem>
              )
            })}
          </Select>
          <FormHelperText>{TitleService('Select a series')}</FormHelperText>
        </FormControl>
        <Grid container spacing={gridSpacing}>
          <Busy />
          <Grid item xs={12} md={3} xl={3}>
            <MainCard title={TitleService('Series')}>{modelList}</MainCard>
          </Grid>
          {params?.id && (
            <Grid item xs={12} md={9} xl={9}>
              {modelForm}
            </Grid>
          )}
        </Grid>
      </>
    )
  }

  let output_main_card = main_card(
    output_seriesComponent,
    output_seasonRelaseManagementComponent,
  )

  return output_main_card
}
